let language = {
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_FROM:"From",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_TO:"To",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_WHITELABLE_PRICE:"Whitelabel Price",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_REVENUE:"Revenue",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_RETAIL_PRICE:"Retail price",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_QTY_MAX:"MAX",

};


export { language }